module.exports = __webpack_public_path__ + "static/media/input-icon-envelope~KQpLWrNf.4f5c729d.svg";